import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import Select from 'react-select';

class QuestionCategoriesTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      category_id: null,
      lista_categorias: [],
      dados: [],
    };
    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionardCategoria = this.adicionardCategoria.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
  }
  
  // Handlers
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.categorias) && Array.isArray(newProps.lista_categorias)) {
      this.setState({dados: newProps.categorias, lista_categorias: newProps.lista_categorias});
    }
  }
  
  adicionardCategoria(event) {
    event.preventDefault();
    var dados_salvar = {
      category_id: this.state.category_id,
      question_id: this.props.question_id,
    };
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/questao/categoria', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(dados_salvar) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      /*<BotaoDeletar url={"/categoria/questao/"+ cell} />*/
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var category_question_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa categoria?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/questao/categoria/' + category_question_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(category_question_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(category_question_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == category_question_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.adicionardCategoria}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Categoria:</label>
            <Select
              className="form-field-name"
              name="category_id"
              value={this.state.category_id}
              searchable={true}
              placeholder={'Selecionar Categoria'}
              onChange={this.handleSelectChange.bind(this, 'category_id')}
              options={this.state.lista_categorias}
            />    
        </div>
      </div>
      <div className="col-md-6">
        <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> Adicionar categoria</button>
      </div>
    </div>
  </form>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há categorias cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="categoria" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Categoria</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default QuestionCategoriesTab;



// WEBPACK FOOTER //
// ./src/Components/Questions/Elements/QuestionCategoriesTab.js